"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarningLabel = void 0;
const barcode_1 = require("client/components/barcode");
const checkbox_1 = require("client/components/material/checkbox/checkbox");
const store_1 = require("client/modules/orders/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const react_1 = require("react");
const React = require("react");
require("./warning-label.less");
const isPrinting = window.location.href.includes("print-labels");
let WarningLabel = class WarningLabel extends react_1.Component {
    constructor(props) {
        super(props);
        this.reqCounsel = false;
        this.renderHeader = (inventory, patient) => (React.createElement("tr", null,
            React.createElement("td", { colSpan: 2, className: "warning-label__header" },
                React.createElement("table", null,
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", { className: "warning-label__info" },
                                React.createElement("span", { className: "warning-label__name" },
                                    patient.lastName,
                                    ", ",
                                    patient.firstName),
                                React.createElement("br", null),
                                [patient.address, patient.address2].join("").trim(),
                                ",",
                                " ",
                                patient.city,
                                " ",
                                patient.state,
                                " ",
                                patient.zip,
                                React.createElement("br", null),
                                "DOB: ",
                                moment(patient.birthDate).format("MM/DD/YYYY"),
                                " ",
                                "\u00A0\u00A0",
                                patient.gender === "1" ? "Male" : "Female"),
                            isPrinting && (React.createElement("td", null,
                                React.createElement(barcode_1.UiBarcode, { background: "transparent", displayValue: true, height: 80, lineColor: "#26324e", value: inventory.barCode, margin: 0, marginLeft: 20, width: 1 })))))))));
        this.renderTitle = () => (React.createElement("tr", null,
            React.createElement("td", { className: "warning-label__title-container", colSpan: 2 },
                React.createElement("br", null),
                React.createElement("span", { className: "warning-label__title" }, "Medication Instructions / Warnings / Counseling"))));
        this.renderSignature = (claim) => isPrinting && (React.createElement("tr", null,
            React.createElement("td", { colSpan: 2 },
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement("div", { className: "warning-label__signature" },
                    React.createElement("div", { className: "warning-label__signature-label" },
                        "Patient Signature: \u00A0",
                        " "),
                    React.createElement("div", { className: "sig-pad" },
                        React.createElement("img", { src: claim.signature, className: "signature" }),
                        React.createElement("div", { className: "sig-pad__baseline" })),
                    React.createElement("div", { className: "warning-label__signature-label" }, "Date: \u00A0 "),
                    React.createElement("div", { className: "date-pad" },
                        React.createElement("div", { className: "date-pad__baseline" }))))));
    }
    async handleCheckBox(value, orderId) {
        this.reqCounsel = value;
        await store_1.ordersStore.saveCounsel(orderId, value);
    }
    render() {
        // console.log(ordersStore);
        const claim = store_1.ordersStore.claim.value;
        const order = claim && claim.order;
        const patient = claim && order.patient;
        const status = claim && claim.status;
        let inventory = claim && claim.inventory;
        // We only need to show all the medications if we're not printing labels.
        const claims = isPrinting || !store_1.ordersStore.claimsGroup.value
            ? [claim]
            : store_1.ordersStore.selectedClaims.map((claim) => claim);
        // This is what was originally here; I replaced it after pushing selectedClaims through about 8 files.
        // : ordersStore.claimsGroup.value
        //     .reduce((a: IClaim[], c) => a.concat(...c.children), [])
        //     .map(item => {
        //       const arry = [];
        //       while (arry.length < item.quantity) {
        //         arry.push(item);
        //       }
        //       return arry;
        //     })
        //     .reduce((a, c) => a.concat(...c), [])
        //     .filter(claim => claim.status === status);
        return (React.createElement("div", { className: "warning-label" },
            React.createElement("table", null,
                React.createElement("tbody", null,
                    inventory && patient && this.renderHeader(inventory, patient),
                    this.renderTitle(),
                    React.createElement("tr", null,
                        React.createElement("td", { colSpan: 2 },
                            React.createElement("b", null, "Important:"),
                            "\u00A0Please review these important instructions and medication warnings about the medications being dispensed to you. These are summaries and do NOT have all possible information about these products. This information is not individual medical advice and does not substitute for the advice of your health care professional. Always ask your health care professional for complete information about these products and your specific health needs.",
                            React.createElement("br", null),
                            React.createElement("br", null))),
                    React.createElement("tr", null,
                        React.createElement("td", { colSpan: 2 },
                            React.createElement("b", null, "Call your doctor for medical advice about side effects. You may report side effects to FDA at 1-800-FDA-1088."),
                            React.createElement("br", null),
                            React.createElement("br", null))),
                    React.createElement("tr", null,
                        React.createElement("td", { colSpan: 2 },
                            "These instructions are specifically for",
                            " ",
                            React.createElement("b", null, patient && `${patient.firstName} ${patient.lastName}`),
                            ". If this is not you, please disregard these instructions and contact your health care professional.",
                            React.createElement("br", null),
                            React.createElement("br", null))),
                    claims.map((claim, index) => {
                        if (claims.length > 1)
                            inventory = claim.inventory;
                        if (index !== 0 &&
                            inventory.id === claims[index - 1].inventory.id) {
                            return React.createElement("b", null, "Medication does not include instructions.");
                        }
                        return (React.createElement(React.Fragment, null,
                            React.createElement("tr", { key: index },
                                React.createElement("th", { colSpan: 2 },
                                    "Rx #",
                                    claim && claim.rxId && ` ${claim.rxId.rxId} `,
                                    inventory &&
                                        `${inventory.package}: ${inventory.name} ${inventory.strength} ${inventory.unit}`)),
                            inventory && inventory.defaultSig && (React.createElement("tr", null,
                                React.createElement("td", { className: "warning-label__bullet" }, "\u2022"),
                                React.createElement("td", null,
                                    React.createElement("b", null, "Instructions:"),
                                    "\u00A0",
                                    React.createElement("span", null, inventory.defaultSig)))),
                            inventory && inventory.defaultSig2 && (React.createElement("tr", null,
                                React.createElement("td", { className: "warning-label__bullet" }, "\u2022"),
                                React.createElement("td", null,
                                    React.createElement("b", null, "Instructions:"),
                                    "\u00A0",
                                    React.createElement("span", null, inventory.defaultSig2)))),
                            inventory && inventory.defaultSig3 && (React.createElement("tr", null,
                                React.createElement("td", { className: "warning-label__bullet" }, "\u2022"),
                                React.createElement("td", null,
                                    React.createElement("b", null, "Instructions:"),
                                    "\u00A0",
                                    React.createElement("span", null, inventory.defaultSig3)))),
                            React.createElement("tr", null,
                                React.createElement("td", { colSpan: 2 }))));
                    }),
                    React.createElement("tr", null,
                        React.createElement("td", { colSpan: 2 },
                            React.createElement("br", null),
                            React.createElement("b", null,
                                React.createElement("span", { className: "checkOne" },
                                    React.createElement("div", null, "Do you require additional counseling (check one):\u00A0"),
                                    React.createElement("div", null,
                                        React.createElement(checkbox_1.MaterialCheckbox, { onAction: () => this.handleCheckBox(true, order.id), label: "Yes", checked: this.reqCounsel }),
                                        "\u00A0",
                                        React.createElement(checkbox_1.MaterialCheckbox, { onAction: () => this.handleCheckBox(false, order.id), label: "No", checked: !this.reqCounsel })))))),
                    claim && this.renderSignature(claim)))));
    }
};
__decorate([
    mobx_1.observable
], WarningLabel.prototype, "reqCounsel", void 0);
WarningLabel = __decorate([
    mobx_react_1.observer
], WarningLabel);
exports.WarningLabel = WarningLabel;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-detail/components/order-claims/warning-label/warning-label.tsx
// module id = 2989
// module chunks = 0 1